import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-893">
      <PriceAlert data-id="element-894" />
      <Hero data-id="element-895" />
      <Testimonial data-id="element-896" />
      <ProblemSolution data-id="element-897" />
      <ValueStack data-id="element-898" />
      <ModuleBreakdown data-id="element-899" />
      <Guarantee data-id="element-900" />
      <PricingSection data-id="element-901" />
      <Footer data-id="element-902" />
      <RecentPurchaseToast data-id="element-903" />
    </div>;
}